// extracted by mini-css-extract-plugin
export var copyable = "_s-1";
export var explainable = "_s-0";
export var negative = "_s-2";
export var positive = "_s-3";